import type { Filter, LogicalAndFilter } from '@cubejs-client/core';
import { type Period } from '@/types/date';
import { FilterConfigDynamic } from '@/types/filter/filterConfig';
import { isPeriod } from '@/utils/date/isPeriod';

export const buildFilterOptionsQuery = (
  config: FilterConfigDynamic,
  dateRange: unknown,
  optionScopeFilters: Filter[],
  globalFilters: LogicalAndFilter | null,
  comparisonPeriod?: Period,
) => {
  if (!isPeriod(dateRange)) return undefined;
  const query = config.getOptionsQuery({
    sourceCube: config.sourceCube,
    dateRange,
    comparisonPeriod,
  });
  return {
    ...query,
    filters: [...(query.filters ?? []), ...optionScopeFilters, globalFilters],
  };
};
